import { Box, Container, Grid, GridItem, Text, VStack, HStack, Icon, Flex } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

const MotionBox = motion(Box);

const ProblemCard = ({ title, description, delay }) => (
  <MotionBox
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay }}
    viewport={{ once: true, amount: 0.3 }}
    bg="white"
    borderLeft="4px"
    borderLeftColor="red.500"
    p={{ base: 6, md: 8 }}
    borderRadius="lg"
    boxShadow="0 4px 12px rgba(0, 0, 0, 0.1)"
  >
    <HStack spacing={4} mb={4} align="flex-start">
      <Icon as={FaTimes} color="red.500" fontSize="24px" mt={1} />
      <Text as="h3" fontSize={{ base: 'lg', md: 'xl' }} fontWeight="700" color="brand.800">
        {title}
      </Text>
    </HStack>
    <Text fontSize="md" color="gray.600" lineHeight="1.6">
      {description}
    </Text>
  </MotionBox>
);

const GetHiredProblem = ({ data }) => {
  return (
    <Box bg="brand.800" py={{ base: 12, md: 16 }}>
      <Container maxW="6xl">
        <VStack spacing={12} align="center">
          {/* Header */}
          <VStack spacing={4} align="center" textAlign="center" maxW="3xl">
            <Text
              as="h2"
              fontSize={{ base: '2xl', md: '3xl' }}
              fontWeight="900"
              color="white"
            >
              {data.title}
            </Text>
            <Flex
              spacing={3}
              align="center"
              justify="center"
              w="full"
              flexDirection={{ base: 'column', md: 'row' }}
              gap={{ base: 3, md: 4 }}
            >
              <Text fontSize={{ base: 'md', md: 'lg' }} color="gray.300" lineHeight="1.6" whiteSpace="nowrap">
                Real talk: The job market changed.
              </Text>
              <MotionBox
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                bg="white"
                px={{ base: 4, md: 8 }}
                py={{ base: 3, md: 4 }}
                borderRadius="lg"
                w={{ base: 'full', md: 'fit-content' }}
              >
                <Text fontSize={{ base: 'md', md: 'lg' }} fontWeight="900" color="black">
                  {data.subtitle}
                </Text>
              </MotionBox>
            </Flex>
          </VStack>

          {/* Problem Cards Grid */}
          <Grid
            templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
            gap={6}
            w="full"
          >
            {data.problems.map((problem, idx) => (
              <GridItem key={idx}>
                <ProblemCard
                  title={problem.title}
                  description={problem.description}
                  delay={idx * 0.1}
                />
              </GridItem>
            ))}
          </Grid>

          {/* Call-to-action text */}
          <MotionBox
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            viewport={{ once: true }}
            textAlign="center"
          >
            <Text
              fontSize={{ base: 'md', md: 'lg' }}
              color="accent.gold"
              fontWeight="600"
            >
              {data.cta}
            </Text>
          </MotionBox>
        </VStack>
      </Container>
    </Box>
  );
};

export default GetHiredProblem;
